class Chatbot {
    constructor() {
        this.chatbot = {
            displayTimeout: 500, // timeout until the next unit will be displayed
        };

        this.form = {
            action: $('#ajaxUrl').val()
        };

        // console.log('Dialog init');

        this.intializeChat();
        this.initializePlaceholderConverter();
        this.submitForm();
    }

    intializeChat() {
        let self = this;
        $('.chatbot').each(function(index, element) {
            let chat = $(element).find('.chat');
            self.setupConversation(chat);
        });
    }

    initializePlaceholderConverter() {
        let $bubble = $('.bubble');

        $bubble.each(function(index, element) {
            let string = $(element).html(),
                match = string.match(/#\w+#/g);

            if (match !== null) {
                $.each(match, function(index, value) {
                    value = value.split('#')[1];
                    string = $(element).html();
                    let expression = new RegExp('#' + value + '#', 'g'),
                        replaced = string.replace(expression, `<strong data-placeholder="${value}"></strong>`);
                    $(element).html(replaced);
                });
            }
        });
    }

    setPlaceholder(data) {
        let name = data.$element.attr('name');
        let value = (data.type === 'SELECT') ? data.$element.find('option[value=' + data.$element.val() + ']').text() : data.$element.val();
        $('strong[data-placeholder=' + name + ']').text(value)
    }

    setupConversation(chat) {
        let self = this;
        chat.each(function(index, element) {
            let interactionElement = $(element).find('input:enabled, select:enabled, a, textarea');
            interactionElement.each(function(index, element) {
                let interactionElement = $(element),
                    buttonElement = $(element).next('button');

                let chatItem = {
                    $element: interactionElement,
                    $sendButton: buttonElement,
                    name: interactionElement.attr('name'),
                    type: interactionElement.attr('type') || interactionElement.prop('tagName'),
                };

                if (
                    chatItem.type === 'text' ||
                    chatItem.type === 'email' ||
                    chatItem.type === 'tel' ||
                    chatItem.type === 'TEXTAREA'
                ) {
                    chatItem.maxLength = chatItem.$element.attr('maxLength') || 255;
                    chatItem.minLength = chatItem.$element.attr('minlength') || 1;
                }

                if (chatItem.type === 'text') {
                    chatItem.validation = chatItem.$element.attr('data-validate') || 'text';
                    chatItem.$element.on('change', chatItem, self.textInputEvents);
                } else if (chatItem.type === 'email') {
                    chatItem.validation = 'email';
                    chatItem.$element.on('change', chatItem, self.textInputEvents);
                } else if (chatItem.type === 'tel') {
                    chatItem.validation = 'tel';
                    chatItem.$element.on('change', chatItem, self.textInputEvents);
                } else if (chatItem.type === 'checkbox') {
                    chatItem.validation = 'checkbox';
                    chatItem.$element.on('change', chatItem, self.checkboxInputEvents);
                } else if (chatItem.type === 'SELECT') {
                    chatItem.validation = 'select';
                    chatItem.$element.on('change', chatItem, self.selectEvents);
                } else if (chatItem.type === 'A') {
                    chatItem.validation = 'link';
                    if (chatItem.$element.attr("id") !== 'dsgvo') {
                        chatItem.$element.on('click', chatItem, self.buttonEvents);
                    }
                } else if (chatItem.type === 'TEXTAREA') {
                    chatItem.validation = 'message';
                    chatItem.$element.on('change', chatItem, self.textInputEvents);
                }
            });
        });
    }

    /*
    * TEXT-INPUT HANDLER
    * type: text || email || tel
    * */
    textInputEvents = event => {
        let expression = this.inputValidate(event);
        (
            expression === true &&
            event.target.value !== '' &&
            event.target.value.length >= event.data.minLength &&
            event.target.value.length <= event.data.maxLength
        ) ? this.nextChatGroup(event) : this.errorHandler(event);

        // console.log(event);
    };

    checkboxInputEvents = event => {
        let valid = this.inputValidate(event);
        (valid) ? this.nextChatGroup(event) : this.errorHandler(event);
    };

    selectEvents = event => {
        let valid = this.inputValidate(event);
        (valid) ? this.nextChatGroup(event) : this.errorHandler(event);
    };

    buttonEvents = event => {
        event.preventDefault();
        this.nextChatGroup(event)
    };

    inputValidate(event) {
        let regex,
            valid,
            value = event.target.value,
            chars = `${event.data.minLength} - ${event.data.maxLength} Zeichen`;

        switch (event.data.validation) {
            case 'text':
                regex = /./;
                valid = regex.test(value);
                event.data.errorLabel = `Das reicht leider nicht. Bitte nenne uns deinen Vor- und Nachnamen.`;
                break;
            case 'tel':
                regex = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/g;
                valid = regex.test(value);
                event.data.errorLabel = `Konnte nicht gesendet werden! z. B. 06111234567 oder +4915112345678 (${chars})`;
                break;
            case 'email':
                regex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/g;
                valid = regex.test(value);
                event.data.errorLabel = `Das reicht leider nicht. Bitte gebe deine vollständige E-Mail-Adresse ein.`;
                break;
            case 'checkbox':
                event.data.errorLabel = `Konnte nicht gesendet werden. Bitte fülle alle Pflichtfelder aus. `;
                valid = event.data.$element.prop('checked');
                break;
            case 'select':
                event.data.errorLabel = `Konnte nicht gesendet werden. Bitte fülle alle Pflichtfelder aus. `;
                valid = (event.data.$element.val() !== '0');
                break;
            case 'link':
                event.data.errorLabel = `Konnte nicht gesendet werden. Bitte fülle alle Pflichtfelder aus. `;
                valid = true;
                break;
            case 'message':
                event.data.errorLabel = `Konnte nicht gesendet werden. Bitte fülle alle Pflichtfelder aus. `;
                valid = true;
                break;
        }

        return valid;
    }

    nextChatGroup(event) {
        let $chatContainer = event.data.$element.parents('.chat'),
            scrollY = $(window).scrollTop();

        this.setPlaceholder(event.data);

        event.data.$element.addClass('sent');
        event.data.$sendButton.addClass('d-none');
        $chatContainer.find('.error').remove();
        $chatContainer.find('.dot-group').css({ 'display' : 'block' });

        setTimeout(function() {
            $chatContainer.nextAll().removeClass('temp-inactive');
            $chatContainer.find('.dot-group').css({ 'display' : 'none' });
            $chatContainer.next().addClass('active');
            $(window).scrollTop(scrollY + 150);
        }, this.chatbot.displayTimeout)
    }

    errorHandler(event) {
        let $chatContainer = event.data.$element.parents('.chat');
        $chatContainer.nextAll().addClass('temp-inactive');
        $chatContainer.find('.error').remove();
        event.data.$element.removeClass('sent');

        $('<div/>', {
            'id': event.data.name + '-error',
            'class': 'error',
            'text': event.data.errorLabel
        }).appendTo($chatContainer);
    }

    submitForm() {
        let self = this;
        $('#submitForm').on('click', function() {
            let data = {
                name: $('.chatbot #name').val(),
                email: $('.chatbot #email').val(),
                message: $('.chatbot #message').val(),
                topic: $('.chatbot #topic').val()
            };
            self.post('processForm', JSON.stringify(data));
        });
    }

    /**
     * @param {string} action
     * @param {string} data
     */
    post(action, data) {
        let requestData = {
                action: action,
                data: data
            },
            formData = new FormData();

        for (let name in requestData) {
            formData.append(`tx_wmdtemplate_pi1[${name}]`, requestData[name]);
        }

        let httpRequest = new XMLHttpRequest();
        httpRequest.open('POST', this.form.action, true);
        httpRequest.send(formData);
    }
}

// Textarea auto height
$('textarea').on('input', function(){
    $(this).height( 'auto' ).height( $(this)[0].scrollHeight );
});

$(document).ready(() => {
    if ($('.chatbot').length > 0) {
        new Chatbot();
    }
});
